// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2wjvL","row":"ProcedureTreatmentSummary_row__3QRTO"};